import { Col, Icon, Row, Spin } from 'antd';
import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import Slider from 'react-slick';
import { apiImageStatic } from '../../../../../config/config';
import {
  getGalleryPhoto,
  responsiveSliderSettingsProduct
} from '../../../../utils/utils';
import ProductMainImage from '../ProductMainImage';
import { Media } from '../../../../Media';

export default class ProductSliderDesktop extends Component {
  state = {
    activeGalleryPhoto: '',
    fadeIn: false,
    fadeOut: true,
    key: 0,
    videoIsReady: false,
    videoSection: false,
    videoUrl: ''
  };

  componentDidMount() {
    const { product, activeGalleryPhoto } = this.props;
    this.setState({
      activeGalleryPhoto: activeGalleryPhoto || getGalleryPhoto(product),
      key: this.state.key + 1,
      nav2: this.slider2
    });
  }

  componentDidUpdate(prevProps) {
    const { product, activeGalleryPhoto } = this.props;
    if (
      prevProps.product !== product ||
      prevProps.activeGalleryPhoto !== activeGalleryPhoto
    ) {
      this.setState({
        activeGalleryPhoto: activeGalleryPhoto || getGalleryPhoto(product)
      });
    }
  }

  onVideoChange = (video) => {
    this.setState({ videoSection: true, videoUrl: video });
  };

  onGalleryPhotoChange = (image) => {
    this.setState({
      activeGalleryPhoto: `${apiImageStatic}/product/${this.props.product._id}/${image}`,
      fadeIn: !this.state.fadeIn,
      fadeOut: !this.state.fadeOut,
      key: this.state.key + 1,
      videoIsReady: false,
      videoSection: false
    });
  };

  render() {
    const {
      activeGalleryPhoto,
      fadeIn,
      fadeOut,
      videoIsReady,
      videoSection,
      videoUrl
    } = this.state;

    const { product, productId, sliderImages, sliderVideos } = this.props;

    const videoSpiner = (
      <Icon type="loading" style={{ fontSize: 28, color: '#546d52' }} spin />
    );

    return (
      <>
        {/* desktop */}
        <Media greaterThanOrEqual="sm">
          {/* product short rebuilt */}
          <Row>
            {/* main image slider */}
            <Slider asNavFor={this.state.nav2} ref={(slider) => (this.slider1 = slider)}>
              {videoSection ? (
                <Col className="slider-main-image-container" span={24}>
                  <Spin indicator={videoSpiner} size="large" spinning={!videoIsReady}>
                    <ReactPlayer
                      controls
                      height={500}
                      muted
                      onEnded={() => this.setState({ videoSection: !videoSection })}
                      onReady={() => this.setState({ videoIsReady: true })}
                      playing
                      url={videoUrl}
                      width="100%"
                    />
                  </Spin>
                </Col>
              ) : (
                <Col className="slider-main-image-container" span={24}>
                  <ProductMainImage
                    activeGalleryPhoto={activeGalleryPhoto}
                    fadeIn={fadeIn}
                    fadeOut={fadeOut}
                    product={product}
                  />
                </Col>
              )}
            </Slider>
            {/* gallery slider */}
            <Col md={24} xs={0} className="product-slider">
              {sliderImages.length === 1 ? null : (
                <>
                  <Slider {...responsiveSliderSettingsProduct}>
                    {sliderImages.map((image) => {
                      return (
                        <div
                          className="gallery-img-container hover"
                          key={image.image.uid}
                        >
                          <img
                            alt="product"
                            className="img-fluid-inv"
                            onClick={() => this.onGalleryPhotoChange(image.image.name)}
                            src={`${apiImageStatic}/product/${productId}/${image.thumbs[2].name}`}
                          />
                        </div>
                      );
                    })}
                    {sliderVideos.map((video, i) => {
                      return (
                        <div key={i.toString()}>
                          <div className={!this.props.isLong ? '' : ''}>
                            <Icon
                              className="video-btn hover"
                              onClick={() => this.onVideoChange(video)}
                              type="play-circle"
                            />
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </>
              )}
            </Col>
          </Row>
        </Media>
        <Media lessThan="sm">
          <Row type="flex" justify="center">
            <Col span={24}>
              <Slider
                dots={false}
                arrows={false}
                infinite="true"
                slidesToShow={1}
                slidesToScroll={1}
              >
                {sliderImages.map((image) => {
                  return (
                    <div className="gallery-img-container hover" key={image.image.uid}>
                      <img
                        alt="product"
                        className="img-fluid-inv"
                        src={`${apiImageStatic}/product/${productId}/${image.thumbs[2].name}`}
                      />
                    </div>
                  );
                })}
                {sliderVideos.map((video, i) => {
                  return (
                    <div key={i.toString()}>
                      <div className={!this.props.isLong ? '' : ''}>
                        <Icon
                          className="video-btn"
                          onClick={() => this.onVideoChange(video)}
                          type="play-circle"
                        />
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </Col>
          </Row>
        </Media>
      </>
    );
  }
}
